import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const LanguageDropdown = ({ seriesData, languages, onSelectOption }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);
    const selectOption = (option) => {
        onSelectOption(option);
        setIsDropdownOpen(false);
    };
    return <div className="relative">
        <button
            onClick={toggleDropdown}
            className="w-full p-2 border border-gray-300 rounded-lg bg-white text-left flex justify-between items-center focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
        >
            <span>{seriesData.language || "Select a language"}</span>
            <ChevronDown className={`w-5 h-5 transition-transform duration-200 ${isDropdownOpen ? 'transform rotate-180' : ''}`} />
        </button>
        {isDropdownOpen && (
            <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-60 overflow-y-auto">
                {languages.map((language) => (
                    <button
                        key={language}
                        onClick={() => selectOption(language)}
                        className="w-full p-2 text-left hover:bg-indigo-100 transition-colors duration-200"
                    >
                        {language}
                    </button>
                ))}
            </div>
        )}
    </div>
};

export default LanguageDropdown;
